import RootState from '@/store/root_state';
import { CalendarState } from './state';
import { GetterTree } from 'vuex';
import { UserCalendar } from '@/services/undergrad/pegasus-epona/user-calendar.service';

const getters: GetterTree<CalendarState, RootState> = {
  userCalendar: (state): UserCalendar | undefined => {
    return state.userCalendar;
  },
  isConnectingCalendar: (state): boolean => {
    return state.isConnectingCalendar;
  },
};

export default getters;
